/**
 * @packageDocumentation
 * @module f1/is
 */

import { t_value } from '../types';

export interface IsSimilar {
  /**
   * Is the value similar, but not type-safe equal, same as `==`
   *
   * @public
   * @function f1.is.similar
   * @example
   *
   * ```ts
   * f1.is.similar(1, '1') => true
   * f1.is.similar(1, 1) => true
   * ```
   */
  (x: t_value, y: t_value): boolean;
  /**
   *
   */
  (x: t_value): (y: t_value) => boolean;
}

/**
 * @see IsSimilar
 */
export default (x: t_value, y: t_value) => x == y;
